export default {
    FreightServiceType: {
        NORMAL: "Dịch vụ thường",
        PLUS: "Dịch vụ cộng thêm"
    },
    CommonStatus: {
        Active: "Hoạt động",
        InActive: "Không hoạt động"
    },
    ServiceFeeType: {
        Normal: "Chính",
        Hierarchy: "Cộng thêm"
    },
    ServiceAddFeeType: {
        Normal: "Thường",
        Hierarchy: "Theo bậc",
        Min: "Tối thiểu"
    },
    EmployeeType: {
        Shipper: "Nhân viên giao hàng",
        Teller: "Nhân viên văn phòng"
    },
    LadingPaymentType: {
        Cash: "Tiền mặt",
        Receiver: "NN trả",
        Debit: "Ghi nợ"
    },
    LadingPickupType: {
        Home: "Lấy tận nơi",
        PostOffice: "Gửi bưu cục"
    },
    LadingType: {
        Normal: "Đơn mới",
        Forward: "Đơn chuyển tiếp",
        Retransport: "Đơn chuyển hoàn"
    },
    LadingStatus: {
        GdKhoiTao: "Khởi tạo",
        DuyetHoan: "Duyệt hoàn",
        DangHoan: "Đang hoàn",
        HoanThanhCong: "Hoàn thành công",
        NhapKhoGiaoHang: "Nhập kho giao hàng",
        NhapKhoChuyenVung: "Nhập kho chuyển vùng",
        DangChuyenVung: "Đang chuyển vùng",
        LayHangThanhCong: "Lấy hàng thành công",
        ChoLayHang: "Chờ lấy hàng",
        ChoCapNhat: "Chờ lấy hàng-Chờ cập nhật",
        LayHangThanhCongChoCapNhat: "Lấy hàng thành công chờ cập nhật",
        PhanCongPhat: "Phân công phát",
        DiPhat: "Đi phát",
        PhatThanhCong: "Phát thành công",
        PhatLai: "Phát lại",
        DonSuCo: "Đơn sự cố",
        NhapKhoChoCapNhat: "Nhập kho chờ cập nhật",
        NhapKhoChuyenHoan: "Nhập kho chuyển hoàn",
        ChuyenTiep: "Chuyển tiếp",
        DuyetChuyenTiep: "Duyệt chuyển tiếp",
        DiHoan: "Đi hoàn",
        PhanCongHoan: "Phân công hoàn",
        Reject: "Hủy"
    },
    StockInType: {
        NKHangDaNhan: "Nhập kho hàng đã nhận",
        NKHangTrungChuyen: "Nhập kho hàng chuyển vùng",
        NKHangMoiTao: "Nhập kho hàng mới tạo"
    },
    PickingListType: {
        Transhipment: "Trung chuyển",
        Delivery: "Giao hàng"
    },
    PickupStatus: {
        ChoXacNhan: "Chờ xác nhận",
        LayThanhCong: "Lấy thành công",
        ShipperHuy: "Shipper huỷ",
        XacNhanLay: "Xác nhận lấy",
        DaPhanLai: "Đã phân lại"
    },
    PickupType: {
        SystemAssign: "Hệ thống",
        EmployeeAssign: "Nhân viên phân"
    },
    PartnerType: {
        Acceptance: "Đối tác nhận",
        Delivery: "Đối tác phát",
        Transhipment: "Đối tác vận chuyển",
    },
    PickingListTranshipmentStatus: {
        Transhipmenting: "Đang chuyển vùng",
        ConfirmedTranshipment: "Xác nhận đến",
        WaitingConfirm: "Chờ xác nhận",
        Reject: "Đã hủy"
    },
    ReportDeliveryStatus: {
        PHAT_THANH_CONG: "Phát thành công",
        PHAT_LAI: "Phát lại",
        DON_HANG_SU_CO: "Đơn hàng sự cố",
        CHUYEN_HOAN: "Chuyển hoàn",
        HOAN_THANH_CONG: "Hoàn thành công"
    },
    ComplaintStatus: {
        ChuaXuLy: "Chưa xử lý",
        DaXuLy: "Đã xử lý"
    },
    LadingErrorStatus: {
        ChoXuLy: "Chờ xử lý",
        DaXuLy: "Đã xử lý"
    },
    RoleType: {
        Common: "Bưu cục",
        System: "Hệ thống"
    },
    DivisionPickupStatus: {
        ChoXacNhan: "Chờ xác nhận",
        LayThanhCong: "Lấy thành công",
        ShipperHuy: "Shipper huỷ",
        XacNhanLay: "Xác nhận lấy",
        DaPhanLai: "Đã phân lại"
    },
    LadingCodeStatus: {
        Active: "Chưa sử dụng",
        InActive: "Đã sử dụng"
    },
    LadingCodePrintStatus: {
        NotPrint: "Chưa in",
        Printed: "Đã in"
    },
    ReceiptPaymentType: {
        Cash: "Tiền mặt",
        Transfer: "Chuyển khoản"
    },
    ReceiptExpensesPickingListTargetType: {
        Customer: "Khách hàng",
        Employee: "Nhân viên",
        Partner: "Đối tác",
        PostOffice: "Bưu cục"
    },
    ReceiptExpensePickingListPayStatus: {
        Collected: "Đã thu",
        NotYetCollect: "Chưa thu",
        Payed: "Đã trả",
        NotYetPay: "Chưa trả",
        AwaitConfirm: "Chờ xác nhận",
        Confirm: "Xác nhận",
    },
    ExpensePaymentType: {
        Cash: "Tiền mặt",
        Transfer: "Chuyển khoản"
    },
    BillLadingFeeType: {
        FeeReceiver: "Phí nhận",
        FeeDelivery: "Phí giao",
        FeePostOfficeDelivery: "Phí bưu cục phát",
        FeeOther: "Phí khác"
    },
    ClearingDebtType: {
        Yes: "Cấn trừ cước",
        No: "Không cấn trừ cước"
    },
    PickingListDeliveryStatus: {
        WaitingConfirm: 'Chờ xác nhận',
        Confirmed: 'Đã xác nhận',
        Reject: 'Đã xóa'
    },
    PickingListReTransportStatus: {
        WaitingConfirm: 'Chờ xác nhận',
        Confirmed: 'Đã xác nhận',
        Success: 'Thành công',
        Reject: 'Đã xóa'
    },
    LadingCustomerStatus: {
        DiPhat: 'Đi phát',
        PhatThanhCong: 'Phát thành công',
        PhatKhongThanhCong: 'Phát không thành công',
        ChoLayHang: 'Chờ lấy hàng',
        LayHangThanhCong: 'Lấy hàng thành công',
        DuyetHoan: 'Duyệt hoàn',
        DangHoan: 'Đang hoàn',
        HoanThanhCong: 'Hoàn thành công',
        Reject: 'Hủy'
    }
}
